import { useFormatShortDate as formatShortDate, useFormatTime as formatTime, } from '@coolblue-development/next-formatting-utils/client';
import { differenceInCalendarDays, format, parseISO } from 'date-fns';
export const getPreOrderAvailability = ({ expectedReleaseDate, schedules, timeTravelOverride, t, }) => {
    let nextAvailablePickup = '';
    const releaseDate = new Date(expectedReleaseDate);
    const releaseDaySchedule = schedules.find(schedule => schedule.scheduleDate === expectedReleaseDate);
    const now = timeTravelOverride ? new Date(timeTravelOverride) : new Date();
    const today = format(now, 'yyyy-MM-dd');
    const daysUntilRelease = differenceInCalendarDays(parseISO(expectedReleaseDate), parseISO(today));
    if (releaseDaySchedule) {
        const pickupTime = releaseDaySchedule.pickupTime;
        const todayPickupTime = new Date(`${today}T${pickupTime}`);
        if (daysUntilRelease === 1) {
            nextAvailablePickup = t('preOrderPickupTomorrow', {
                pickupTime: formatTime(todayPickupTime),
            });
        }
        else {
            nextAvailablePickup = t('preOrderPickupWithinTwoWeeks', {
                releaseDate: formatShortDate(releaseDate),
                pickupTime: formatTime(todayPickupTime),
            });
        }
    }
    else {
        nextAvailablePickup = t('preOrderPickupMoreThanTwoWeeksAway', {
            releaseDate: formatShortDate(releaseDate),
        });
    }
    return {
        promise: t('preOrder'),
        description: nextAvailablePickup,
    };
};
//# sourceMappingURL=getPreOrderAvailability.js.map